
import React, { useEffect, useMemo, useState } from 'react';
import { Box, FormControl, InputLabel, Link, MenuItem, Select, Typography, Button, Checkbox, debounce, TextField } from '@mui/material';
import { Formik, Field, Form } from 'formik';
import arrowleft from '../../../src/assests/images/arrow-red.svg';
import * as Yup from 'yup';
import { styled } from '@mui/material/styles';
import { teamform, getmodules, getteamlist, approverequest, getTeamById, pauseaccount, getmodulename, getmodulesowner } from './api';
import { decodeJWT, getToken } from "../../utils/utils";
// import { useRouter } from 'next/router';

import { useNavigate, useParams } from 'react-router-dom';
import ConfirmPopup from './ConfirmPopup';
import SuccessPopup from './SuccessPopup';
import { useAlert } from "../../pages/AlertContext/AlertContext";
import axios from 'axios';


const LineArrow = () => (
  <svg
    width="14"
    height="8"
    viewBox="0 0 14 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M1 1L7 7L13 1" stroke="#000" strokeWidth="1.5" />
  </svg>
);
const token = getToken();
interface ObjectValues {
  first_name: string;
  last_name: string;
  mobile_num: string;
  company_email_id: string;
  team_id: string;
  module_id: string[];
  mainmodule_id: number[]
  module_owner: string;
  login_id: string;
  login_password: string;

}
interface FormValues {

  id: string; // Add id property here
  first_name: string;
  last_name: string;
  mobile_num: string;
  company_email_id: string;
  team_id: string;
  module_id: string[];
  mainmodule_id: number[]
  module_owner: string;
  login_id: string;
  login_password: string;
}
type TeamItem = {
  id: string | number;
  team_name: string;
};

// const TeamForm = () => {
 interface TeammembersProps {
    checked?: boolean; // Optional to match ProtectedRoute
    setChecked?: React.Dispatch<React.SetStateAction<boolean>>;
     
  }


  
  const TeamForm: React.FC<TeammembersProps> = ({ checked, setChecked }) => {
  // const team = ['All Team', 'PMI Internal', 'Lollypop Team',];
  // const dash = ['Dashboard, Reports', 'PMI Internal', 'Lollypop Team',];
 const decodedToken = decodeJWT(token);

const [team, setteam] = useState<TeamItem[]>([]);
  const [generatedPassword, setGeneratedPassword] = useState('');
  const [allstadata, setallstadata] = useState('');

  const [modulename, setmodulename] = useState('');
  const [objectvalues, setobjectvalues] = useState<ObjectValues>({
    first_name: "",
    last_name: "",
    mobile_num: "",
    company_email_id: "",
    team_id: "",
    module_id: [],
    mainmodule_id: [],
    module_owner: "",
    login_id: "",
    login_password: ""
  });

  const [modules, setModules] = useState([]);
  const [showSuccess, setShowSuccess] = useState(false);
  const [statusdata, setstatusdata] = useState(false);
    const [moduleiddrop, setmoduleiddrop] = useState('');
  const { showAlert } = useAlert();
  const { id } = useParams();
  const [selectedModuleIds, setSelectedModuleIds] = useState<number[]>([]);
   const [selectedModuleIds33, setSelectedModuleIds33] = useState<number[]>([]);
  const [selectedModuleIds22, setSelectedModuleIds22] = useState<number[]>([]);
  const [selectdatata, setdatata] = useState<number[]>([]);
   const ememem=decodedToken?.email
   const isis=decodedToken?.id
  const { id: urlId } = useParams<{ id: string }>();

  const { copyid } = useParams();
  console.log(copyid, "copyideeeeeeeeeeeeeeeeee")
  console.log(id, "ideeeeeeeeeeeeeeeeeeeee")
  const navigate = useNavigate();
  console.log(selectedModuleIds, "selectedModuleIds")
     const userRole = decodedToken?.user_role_name || "guest";
    const roleNames: string[] = decodedToken?.roleNames || [];

const derivedRole = useMemo(() => {
  if (checked && roleNames.includes("Admin") && roleNames.includes("Module Owner")) {
    return "Admin";
  } else if (!checked && roleNames.includes("Admin") && roleNames.includes("Module Owner")) {
    return "Module Owner";
  } else if (userRole === "Admin") {
    return "Admin";
  } else if (userRole === "Module Owner") {
    return "Module Owner";
  }
  return "";
}, [checked, roleNames, userRole]);
  const [initialValues, setInitialValues] = useState<FormValues>({
    id: '',
    first_name: '',
    last_name: '',
    mobile_num: '',
    company_email_id: '',
    team_id: '',
    module_id: selectedModuleIds.length ? selectedModuleIds.map(String) : [], // Initialize with empty array

    mainmodule_id: selectdatata.length ? selectdatata : [],
    module_owner: '',

    login_id: '',
    login_password: '',
  });

  // useEffect(() => {
  //   setInitialValues((prevValues) => ({
  //     ...prevValues,
  //     module_owner: modulename,
  //   }));
  // }, [modulename]);


  useEffect(() => {
    const newPassword = generatePassword();
    setGeneratedPassword(newPassword);
  }, []);


useEffect(() => {
  const fetchModules = async () => {
    try {
      const res = await getmodules(isis, ememem, derivedRole, token);
      setModules(res?.data?.data || []);
    } catch (error) {
      console.error('Failed to fetch modules:', error);
      setModules([]);
    }
  };

  if (ememem && token) {
    fetchModules();
  }
}, [isis, ememem, derivedRole, token]); // ✅ include all dependencies




  useEffect(() => {
    const fetchTeamData = async () => {
      try {
        const res = await getteamlist(token); // Replace with your API endpoint
        setteam(res?.data?.data || []);; // Assuming the data is in the 'data' field
      } catch (error) {
        console.error("Error fetching team data:", error);
      }
    };

    fetchTeamData();
  }, []);
  const generatePassword = (length = 10) => {
    const chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789@#$!';
    let password = '';
    for (let i = 0; i < length; i++) {
      password += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return password;
  };
  const handleSubmit = async (values: { first_name: string; last_name: string; mobile_num: string; company_email_id: string; team_id: string; module_id: string[]; mainmodule_id: number[]; module_owner: string; login_id: string; login_password: string; }) => {
    try {
      console.log(values, "dddddddddddddd33333333333")
      setobjectvalues(values)


        const response = await teamform(values, token);
        console.log(response.data.success, "dddddddddddddxxxxxxddddddd");

        if (response.data.success === true) {
          showAlert("Team Member successfully Saved!", "success");
          navigate(`/team-Members`);
          setTimeout(() => window.location.reload(), 100);
              // setTimeout(() => navigate('/team-Members'), 100); 
        } else {
          showAlert('Failed to update approval status.');
        }
      }catch (error: any) {
    console.error("Error while saving team member:", error);

    // Safely extract the response message if it exists
    const errorMessage = error?.response?.data?.message || 'An error occurred while saving the team member.';
    
    showAlert(errorMessage, "error");
  }
  };
  
  const handleApprove = async (is_approved: string) => {
    try {
      setallstadata(is_approved)

    } catch (error) {
      console.error('Error during approval:', error);
    }
  };
  const handleYes = async () => {
    console.log("User clicked Yes");

    if (copyid?.startsWith("id:") && allstadata) {

      const id = copyid.replace("id:", "");

      try {
        const response = await approverequest(Number(id), allstadata, token);
        console.log('Approval Response:', response);

        if (response.data.success === true) {
          showAlert('Team member approval status updated successfully!');
             navigate(`/team-Members`);
          setTimeout(() => window.location.reload(), 100);
        } else {
          showAlert('Failed to update approval status.');
        }
      } catch (error: unknown) {
        let errorMessage = 'An error occurred while saving the team member.';

        if (axios.isAxiosError(error) && error.response?.data?.error) {
          errorMessage = error.response.data.error;
        }

        console.error("Error while saving team member:", errorMessage);
        showAlert(errorMessage);
      }
    } else {
      
    }
  };


  
  useEffect(() => {
    const fetchTeamData = async () => {


      if (!copyid || !copyid.startsWith("id:")) return;

      // Extract the actual ID (remove "id:" prefix)
      const id = copyid?.replace("id:", "");

setmoduleiddrop(id)

      try {
        const res = await getTeamById(id as string, token);
        const data = res.data.data;
        console.log(data.module_id, "kkkkkkkkllllllllllllllllll")
        setInitialValues({
          id: data.id || '',
          first_name: data.first_name || '',
          last_name: data.last_name || '',
          mobile_num: data.mobile_num || '',
          company_email_id: data.company_email_id || '',
          team_id: Array.isArray(data.team_id) ? data.team_id : [],
          module_id: Array.isArray(data.module_id) ? data.module_id : [],
          mainmodule_id: [],
          module_owner: data.module_owner || '',
          login_id: data.login_id || '',
          login_password: data.login_password || '',
        });
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchTeamData();
  }, [copyid]);

// Move fetchTeamData outside useEffect so it can be reused
const fetchTeamData = async () => {
  if (!copyid || copyid?.startsWith("id:")) return;
  // if (!copyid || !copyid.startsWith("id:")) return;
setmoduleiddrop(copyid)
  try {
    const res = await getTeamById(copyid as string, token);
    const data = res.data.data;
    setSelectedModuleIds33(Array.isArray(data.module_id) ? data.module_id : []);
    setInitialValues({
      id: '',
      first_name: '',
      last_name: '',
      mobile_num: '',
      company_email_id: '',
      team_id: Array.isArray(data.team_id) ? data.team_id : [],
      module_id: Array.isArray(data.module_id) ? data.module_id : [],
      mainmodule_id:  Array.isArray(data.module_owner_id) ? data.module_owner_id : [],
      module_owner: data.module_owner || '',
      login_id: '',
      login_password: '',
    });
  } catch (error) {
    console.error("Error fetching data:", error);
  }
};

useEffect(() => {
  fetchTeamData();
}, [copyid]);

// useEffect(() => {
//   if (selectdatata.length > 0) {
//     fetchTeamData();
//   }
// }, [selectdatata]);



console.log(selectdatata, "selectdatatasss")
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [modulenamoopup, setmodulenamoopup] = useState('');

  const handleOpenConfirm = () => {
    setConfirmOpen(true);
  };

  const handleCloseConfirm = () => {
    setConfirmOpen(false);
  };

  const handleConfirmSubmit = () => {
    // perform form submit action here
    console.log('Form submitted!');
    setConfirmOpen(false);
  };




  const handleModuleChange = debounce(async (selected, form, token) => {
    try {
console.log(selected, "lllllllllllll")
      const res = await getmodulename(selected, token);
      const moduleOwner = res?.data?.data?.datas?.module_owner_name;

      console.log(res?.data?.data?.datas.module_id, "Fsssssssetched Module Names");
      console.log(res?.data?.data?.result.map((item: { module_owner_id: any; }) => item.module_owner_id), "55555444444444");
      const datata = res?.data?.data?.result
        .map((item: { module_owner_id: any }) => item.module_owner_id)
        .flat()
        .filter((id: null | undefined) => id !== undefined && id !== null);
      console.log(datata, "datata88899999999")
      if (moduleOwner) {
        setmodulenamoopup(moduleOwner)
        form.setFieldValue("module_owner", moduleOwner);
        form.setFieldValue(
          "mainmodule_id",
          datata
        );
        setSelectedModuleIds22(res?.data?.data?.datas.module_id)
      }

    } catch (err) {
      console.error("Error fetching module name:", err);
      form.setFieldValue("module_owner", '');
    }
  }, 300);

  console.log(selectedModuleIds22, "selectedModuleIds22pppppp")
  console.log(selectedModuleIds, "selectedModuleIdss888888888")
  console.log(objectvalues, "statusdata8888888888888")
  
    console.log(decodedToken, "decodedTokendecodedTokendecodedToken",token, "tokentokentokentoken")
const mainemaill = decodedToken?.email || "guest";
console.log(copyid, "copyidcopyid")
useEffect(() => {
  if (copyid && !initialValues.team_id && team.length > 0) {
    setInitialValues((prev) => ({
      ...prev,
      team_id: String(team[0].id),
    }));
  }
}, [copyid, team, initialValues.team_id]);


console.log(selectedModuleIds, "selectedModuleIds")
console.log(selectedModuleIds33, "selectedModuleIds33")
const validationSchema = copyid
  ? Yup.object({
      first_name: Yup.string().required('First name is required'),
      last_name: Yup.string().required('Last name is required'),
      mobile_num: Yup.string().required('Mobile number is required'),
      company_email_id: Yup.string()
        .email('Invalid email format')
        .required('Email ID is required'),
      login_id: Yup.string().required('Login ID is required'),
      login_password: Yup.string().required('Password is required'),
    })
  : Yup.object({
      first_name: Yup.string().required('First name is required'),
      last_name: Yup.string().required('Last name is required'),
      mobile_num: Yup.string().required('Mobile number is required'),
      company_email_id: Yup.string()
        .email('Invalid email format')
        .required('Email ID is required'),
      team_id: Yup.mixed()
  .test('team-id-valid', 'Team is required', function (value) {
    if (typeof value === 'string') {
      return value.trim() !== '';
    }
    if (Array.isArray(value)) {
      return value.length > 0;
    }
    return false;
  }),
      module_id: Yup.array()
        .min(1, 'Module Ownership is required')
        .of(Yup.mixed().required()),
      module_owner: Yup.string().required('Module Owner is required'),
      login_id: Yup.string().required('Login ID is required'),
      login_password: Yup.string().required('Password is required'),
    });
  const accessData = decodedToken?.access || [];
  return (
    <Box>


      <Box sx={{ backgroundColor: "#F9FBFC", padding: "32px 32px 0" }}>
        <Box sx={{ borderBottom: "1px solid #E7E8E9", paddingBottom: "20px" }}>
          <Box
            sx={{
              textDecoration: "none",
              fontSize: 14,
              fontWeight: 600,
              color: "rgba(142, 2, 15, 1)",
              display: "flex",
            }}
          >
            <Typography sx={{ color: "#696A6B", marginRight: "10px" }}>
              <Link
                href="/team-Members" sx={{ color: "#696A6B", textDecoration: "none", fontSize: 14, }}> Team Member </Link>/
            </Typography>{" "}
            Add Team Members
          </Box>

          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Typography
              variant="h3"
              sx={{ fontSize: 24, fontWeight: 600, color: "#000", marginTop: "16px" }}
            >
              Add Team Members
            </Typography>
          </Box>
        </Box>
        <Box sx={{ marginTop: "30px" }}>
          <label
            style={{
              fontSize: "16px",
              fontWeight: "500",
              color: "#8C8C8C",
              marginBottom: "8px",

            }}
          >
            INFORMATION
          </label>
        </Box>
        <Formik
          initialValues={initialValues}
          enableReinitialize={true}
          // initialValues={{
          //   id:'',
          //   first_name: '',
          //   last_name: '',
          //   mobile_num: "",
          //   company_email_id: "",
          //   team_id: "",
          //   module_id: "",
          //   module_owner: "",
          //   login_id: "",
          //   login_password: "",

          // }}
          // onSubmit={handleSubmit}
          validationSchema={validationSchema}
          
        onSubmit={handleSubmit} // Using the handleSubmit function to send data to the API
        >



          {({ errors, touched, isValid, dirty, values ,setFieldValue}) => (
            <Form>
              <Box mt={3} sx={{ display: "flex", gap: 4, flexWrap: "wrap", width: "800px" }}>
                <FormControl>
                  <label
                    style={{
                      fontSize: "16px",
                      fontWeight: "500",
                      color: "#282829",
                      marginBottom: "8px",
                    }}
                  >
                    First Name*
                  </label>

                  <Field
                    name="first_name"
                    placeholder="First Name"
                    style={{
                      minWidth: "352px",
                      borderRadius: "10px",
                      height: "52px",
                      border: "1px solid #E7E8E9",
                      padding: "14px 12px",
                      color: "#7D7E7F",
                      fontSize: "16px",
                      fontWeight: "500",
                    }}
                  />

                  {errors.first_name && touched.first_name && (
                    <div style={{ color: 'red', fontSize: "14px", fontWeight: "400", marginTop: "4px" }}>
                      {errors.first_name}
                    </div>
                  )}
                </FormControl>

                <FormControl>
                  <label
                    style={{
                      fontSize: "16px",
                      fontWeight: "500",
                      color: "#282829",
                      marginBottom: "8px",
                    }}
                  >
                    Last Name*
                  </label>

                  <Field
                    name="last_name"
                    placeholder="Last Name"
                    style={{
                      minWidth: "352px",
                      borderRadius: "10px",
                      height: "52px",
                      border: "1px solid #E7E8E9",
                      padding: "14px 12px",
                      color: "#7D7E7F",
                      fontSize: "16px",
                      fontWeight: "500",
                    }}
                  />

                  {errors.last_name && touched.last_name && (
                    <div style={{ color: 'red', fontSize: "14px", fontWeight: "400", marginTop: "4px" }}>
                      {errors.last_name}
                    </div>
                  )}
                </FormControl>
                <FormControl>
                  <label
                    style={{
                      fontSize: "16px",
                      fontWeight: "500",
                      color: "#282829",
                      marginBottom: "8px",
                    }}
                  >
                    Mobile Number*
                  </label>

                  <Field
                    name="mobile_num"
                    placeholder="eg. 7666782990"
                    style={{
                      minWidth: "352px",
                      borderRadius: "10px",
                      height: "52px",
                      border: "1px solid #E7E8E9",
                      padding: "14px 12px",
                      color: "#7D7E7F",
                      fontSize: "16px",
                      fontWeight: "500",
                    }}
                  />

                  {errors.mobile_num && touched.mobile_num && (
                    <div style={{ color: 'red', fontSize: "14px", fontWeight: "400", marginTop: "4px" }}>
                      {errors.mobile_num}
                    </div>
                  )}
                </FormControl>

                <FormControl>
                  <label
                    style={{
                      fontSize: "16px",
                      fontWeight: "500",
                      color: "#282829",
                      marginBottom: "8px",
                    }}
                  >
                    Company Email ID*
                  </label>

                  <Field
                    name="company_email_id"
                    placeholder="eg. john.doe@company.com"
                    style={{
                      minWidth: "352px",
                      borderRadius: "10px",
                      height: "52px",
                      border: "1px solid #E7E8E9",
                      padding: "14px 12px",
                      color: "#7D7E7F",
                      fontSize: "16px",
                      fontWeight: "500",
                    }}
                  />

                  {errors.company_email_id && touched.company_email_id && (
                    <div style={{ color: 'red', fontSize: "14px", fontWeight: "400", marginTop: "4px" }}>
                      {errors.company_email_id}
                    </div>
                  )}
                </FormControl>
               <FormControl sx={{ width: "352px" }}>
  <label
    style={{
      fontSize: "16px",
      fontWeight: "500",
      color: "#282829",
      marginBottom: "8px",
    }}
  >
    Team*
  </label>


<Field name="team_id">
  {({ field, form }: any) => {
    const selectedValue = Array.isArray(field.value) ? field.value : [];

    const showError = form.submitCount > 0 && selectedValue.length === 0;

    const handleSelectChange = (event: any) => {
      const value = event.target.value;
      form.setFieldValue("team_id", value);
    };

    return (
      <FormControl sx={{ width: "352px" }}>
        <Select
          multiple
          displayEmpty
          value={selectedValue}
          onChange={handleSelectChange}
          onBlur={() => form.setFieldTouched("team_id", true)}
          renderValue={(selected) => {
            if (!selected || selected.length === 0) {
              return <em style={{ color: "#A0A0A0" }}>Select Team Access</em>;
            }
            const selectedTeams = team.filter((mod) =>
              selected.includes(String(mod.id))
            );
            return selectedTeams.map((mod) => mod.team_name).join(", ");
          }}
          sx={{
            width: "100%",
            borderRadius: "12px",
            backgroundColor: "#fff",
            fontSize: "16px",
            fontWeight: "500",
            color: "#000",
            height: "52px",
            "& .MuiSelect-select": {
              padding: "14px 12px",
            },
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "#E7E8E9",
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: "#E7E8E9",
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: "#E7E8E9",
            },
            "& svg": {
              top: "calc(50% - 4px)",
              right: "12px",
              position: "absolute",
              pointerEvents: "none",
            },
            border: showError ? "1px solid red" : undefined,
          }}
          IconComponent={LineArrow}
          inputProps={{ "aria-label": "Select Team Access" }}
        >
          <MenuItem disabled value="">
            <em style={{ color: "#A0A0A0", fontStyle: "normal" }}>
              Select Team Access
            </em>
          </MenuItem>

          {team.map((mod) => (
            <MenuItem key={mod.id} value={String(mod.id)}>
              <Checkbox
                checked={selectedValue.includes(String(mod.id))}
              />
              {mod.team_name}
            </MenuItem>
          ))}
        </Select>

        {showError && (
          <div style={{ color: "red", fontSize: "14px", marginTop: "4px" }}>
            Please select at least one Team Access
          </div>
        )}
      </FormControl>
    );
  }}
</Field>

  {errors.team_id && touched.team_id && (
                    <div style={{ color: "red", fontSize: "14px", fontWeight: "400", marginTop: "4px" }}>
                      {errors.team_id}
                    </div>
                  )}

  
</FormControl>


{/* <FormControl sx={{ width: { xs: "100%", sm: "352px" } }}>
            <Typography
              component="label"
              sx={{
                fontSize: "16px",
                fontWeight: "500",
                color: "#282829",
                marginBottom: "8px",
              }}
            >
              Team*
            </Typography>
            <Field name="team">
              {(props: FieldProps) => {
                const { field, form, meta } = props;
              
                const isMulti = true; // Set to true for multi-select, false for single-select
                return (
                  <>
                    <Select
                      multiple={isMulti}
                      value={
                        isMulti
                          ? Array.isArray(field.value)
                            ? field.value
                            : []
                          : field.value || ""
                      }
                      onChange={(event) => {
                        form.setFieldValue(field.name, event.target.value);
                      }}
                      displayEmpty
                      id="team"
                      inputProps={{ "aria-label": "Select Team" }}
                      disabled={isDisabled}
                      renderValue={(selected) => {
                        if (!selected || (Array.isArray(selected) && selected.length === 0)) {
                          return (
                            <em style={{ color: "#A0A0A0" }}>Select Team Access</em>
                          );
                        }
                        if (isMulti) {
                          const selectedTeams = team.filter((mod) =>
                            selected.includes(String(mod.id))
                          );
                          return selectedTeams.map((mod) => mod.team_name).join(", ");
                        }
                        const selectedTeam = team.find(
                          (mod) => String(mod.id) === String(selected)
                        );
                        return selectedTeam ? selectedTeam.team_name : "";
                      }}
                      sx={{
                        width: "100%",
                        borderRadius: "12px",
                        backgroundColor: isDisabled ? "#f5f5f5" : "#fff",
                        fontSize: "16px",
                        fontWeight: "500",
                        color: "#000",
                        height: "52px",
                        "& .MuiSelect-select": {
                          padding: "14px 12px",
                          display: "block",
                          alignItems: "center",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        },
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#E7E8E9",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#E7E8E9",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#E7E8E9",
                        },
                        "& svg": {
                          top: "calc(50% - 4px)",
                          right: "12px",
                          position: "absolute",
                          pointerEvents: "none",
                        },
                      }}
                    >
                      {team.map((mod) => (
                        <MenuItem key={mod.id} value={String(mod.id)}>
                          {isMulti && (
                            <Checkbox
                              checked={
                                Array.isArray(field.value) &&
                                field.value.includes(String(mod.id))
                              }
                            />
                          )}
                          {mod.team_name}
                        </MenuItem>
                      ))}
                    </Select>
                    {meta.touched && meta.error && (
                      <div
                        style={{
                          color: "red",
                          fontSize: "14px",
                          fontWeight: "400",
                          marginTop: "4px",
                        }}
                      >
                        {meta.error}
                      </div>
                    )}
                  </>
                );
              }}
            </Field>
          </FormControl> */}





                <FormControl sx={{ width: "352px" }}>
                  <label
                    style={{
                      fontSize: "16px",
                      fontWeight: "500",
                      color: "#282829",
                      marginBottom: "8px",
                    }}
                  >
                    Module Access*
                  </label>
                  <Field name="module_id">
                    {({ field, form }: any) => {
                      const selectedValues = Array.isArray(field.value)
                        ? field.value.map(String)
                        : [];
console.log(selectedValues, "selectedValues8888888888888"); 
                      const showError = form.submitCount > 0 && selectedValues.length === 0;

                      return (
                        <FormControl sx={{ width: "352px" }}>
                          <Select
                            multiple
                            displayEmpty
                            id="module"
                            value={selectedValues}
                            onChange={async (event) => {
                              const selected = typeof event.target.value === 'string'
                                ? event.target.value.split(',')
                                : event.target.value.map(String); // Normalize to strings
                              console.log(selected, "selected8888888888888888");
                              setSelectedModuleIds(selected); // Local state (if needed)
                              form.setFieldValue("module_id", selected); // Formik field update
                              await handleModuleChange(selected , form, token); // Custom logic
                            }}
                            onBlur={() => form.setFieldTouched("module_id", true)}
                            inputProps={{ "aria-label": "Select Module Access" }}
                            IconComponent={LineArrow}
                            renderValue={(selected: any) => {
                              if (selected.length === 0) {
                                return <em style={{ color: "#A0A0A0" }}>Select Module Access</em>;
                              }
                              return modules
                                .filter((mod: any) => selected.includes(String(mod.id)))
                                .map((mod: any) => mod.module_name)
                                .join(", ");
                            }}
                            sx={{
                              width: "100%",
                              borderRadius: "12px",
                              backgroundColor: "#fff",
                              fontSize: "16px",
                              fontWeight: "500",
                              color: "#000",
                              height: "52px",
                              "& .MuiSelect-select": {
                                padding: "14px 12px",
                              },
                              "& .MuiOutlinedInput-notchedOutline": {
                                borderColor: "#E7E8E9",
                              },
                              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                borderColor: "#E7E8E9",
                              },
                              "&:hover .MuiOutlinedInput-notchedOutline": {
                                borderColor: "#E7E8E9",
                              },
                              "& svg": {
                                top: "calc(50% - 4px)",
                                right: "12px",
                                position: "absolute",
                                pointerEvents: "none",
                              },
                              border: showError ? "1px solid red" : undefined,
                            }}
                          >
                            <MenuItem disabled value="">
                              <em style={{ color: "#A0A0A0", fontStyle: "normal" }}>Select Module Access</em>
                            </MenuItem>

                            {modules.map((mod: any) => {
                              const idStr = String(mod.id); // Normalize type
                              return (
                                <MenuItem key={idStr} value={idStr}>
                                  <Checkbox checked={selectedValues.includes(idStr)} />
                                  {mod.module_name}
                                </MenuItem>
                              );
                            })}
                          </Select>

                          {showError && (
                            <div
                              style={{
                                color: "red",
                                fontSize: "14px",
                                fontWeight: "400",
                                marginTop: "4px",
                              }}
                            >
                              Please select at least one Module Access
                            </div>
                          )}
                        </FormControl>
                      );
                    }}
                  </Field>

                  {errors.module_id && touched.module_id && (
                    <div style={{ color: 'red', fontSize: "14px", fontWeight: "400", marginTop: "4px" }}>
                      {errors.module_id}
                    </div>
                  )}
                </FormControl>

                <FormControl sx={{ width: "352px" }}>
                  <label
                    style={{
                      fontSize: "16px",
                      fontWeight: "500",
                      color: "#282829",
                      marginBottom: "8px",
                    }}
                  >
                    Module Owner*
                  </label>
                  <Field name="module_owner">
                    {({ field, form }: any) => (
                      <TextField
                        {...field}
                        placeholder="Module Owner"
                        value={field.value || ""}
                        InputProps={{
                          readOnly: true, // Makes the field non-editable
                        }}
                        sx={{
                          minWidth: "352px",
                          borderRadius: "10px",
                          "& .MuiInputBase-root": {
                            height: "52px",
                            border: "1px solid #E7E8E9",
                            padding: "14px 12px",
                            color: "#7D7E7F",
                            fontSize: "16px",
                            fontWeight: "500",
                            borderRadius: "10px",
                            // backgroundColor: "#F5F5F5", // Optional: Light gray background to indicate read-only
                          },
                        }}
                      />
                    )}
                  </Field>
                  {errors.module_owner && touched.module_owner && (
                    <div style={{ color: "red", fontSize: "14px", fontWeight: "400", marginTop: "4px" }}>
                      {errors.module_owner}
                    </div>
                  )}
                </FormControl>
              </Box>
              <Typography
                sx={{
                  fontSize: "16px",
                  fontWeight: 500,
                  color: "#8C8C8C",
                  marginTop: "32px",
                  marginBottom: "16px",
                  textTransform: "uppercase",
                }}
              >
                Login & Password
              </Typography>

              {/* Login ID and Password Fields */}
              <Box sx={{ display: "flex", gap: 4, flexWrap: "wrap", width: "800px" }}>
                <FormControl>
                  <label
                    style={{
                      fontSize: "16px",
                      fontWeight: "500",
                      color: "#282829",
                      marginBottom: "8px",

                    }}
                  >
                    Provide Login ID*
                  </label>

                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      border: "1px solid #E7E8E9",
                      borderRadius: "10px",
                      height: "52px",
                      minWidth: "352px",
                      paddingLeft: "12px",
                      paddingRight: "12px",
                      background: "#fff",


                    }}
                  >
                    <Field
                      name="login_id"
                      placeholder="Provide Login ID"
                      style={{
                        border: "none",
                        outline: "none",
                        flexGrow: 1,
                        color: "#7D7E7F",
                        fontSize: "16px",
                        fontWeight: "500",
                      }}
                    />
                    <Typography
                      sx={{
                        fontSize: "14px",
                        fontWeight: 500,
                        color: "#C8102E",
                        whiteSpace: "nowrap",
                        cursor: "pointer",
                      }}
                        onClick={() => {
        values.company_email_id && setFieldValue("login_id", values.company_email_id);
      }}
                      
                    >
                      Set as company email
                    </Typography>
                  </Box>
                  {errors.login_id && touched.login_id && (
                    <div style={{ color: "red", fontSize: "14px", marginTop: "4px" }}>{errors.login_id}</div>
                  )}
                  {values.login_id === mainemaill && (
    <div style={{ color: "red", fontSize: "14px", marginTop: "4px" }}>
 Email already exists as a module owner. Please enter a not existed one.

    </div>
  )}

                </FormControl>


                <FormControl>
                  <label
                    style={{
                      fontSize: "16px",
                      fontWeight: "500",
                      color: "#282829",
                      marginBottom: "8px",
                    }}
                  >
                    Provide Password*
                  </label>

                  <Field name="login_password">
                    {({ field, form }: any) => (
                      <Select
                        value={field.value || ""}
                        onChange={(event) => {
                          const selected = event.target.value;
                          let generatedPassword = "";

                          if (selected === "Default") {
                            generatedPassword = generatePassword(8);
                          } else if (selected === "Temporary") {
                            generatedPassword = generatePassword(12);
                          }

                          form.setFieldValue("login_password", generatedPassword);
                        }}
                        displayEmpty
                        IconComponent={LineArrow}
                        sx={{
                          minWidth: "352px",
                          height: "52px",
                          borderRadius: "10px",
                          backgroundColor: "#fff",
                          "& .MuiSelect-select": {
                            padding: "14px 12px",
                            fontSize: "20px", // larger stars
                            fontWeight: "700", // bolder
                            color: "#000",
                          },
                          "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#E7E8E9",
                          },
                          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#E7E8E9",
                          },
                          "&:hover .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#E7E8E9",
                          },
                          "& svg": {
                            top: "calc(50% - 4px)",
                            right: "12px",
                            position: "absolute",
                            pointerEvents: "none",
                          },
                        }}
                        renderValue={(value) => {
                          // if (!value) return ""; // Empty UI when nothing selected
 if (!value) {
                                                            return (
                                                                <span style={{ color: "#A0A0A0", fontSize: "14px", fontWeight: "400", position: "relative", top: "0px" }}>
                                                                    Provide password
                                                                </span>
                                                            );
                                                        }

                          const isDefault = value.length === 8;
                          const isTemporary = value.length === 12;

                          return isDefault
                            ? "********" // Default: 8 stars
                            : isTemporary
                              ? "************" // Temporary: 12 stars
                              : "********"; // fallback
                        }}
                      >
                        {/* <MenuItem disabled value=""> */}
                        {/* <em style={{ color: "#A0A0A0" }}>Provide password</em> */}
                        {/* </MenuItem> */}
                        <MenuItem value="Default">Default</MenuItem>
                        <MenuItem value="Temporary">Temporary</MenuItem>
                      </Select>
                    )}
                  </Field>

                  {errors.login_password && touched.login_password && (
                    <div style={{ color: "red", fontSize: "14px", marginTop: "4px" }}>
                      {errors.login_password}
                    </div>
                  )}
                </FormControl>



              </Box>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  backgroundColor: '#FFF8E1',
                  padding: '12px 16px',
                  borderRadius: '8px',
                  marginTop: '24px',
                  width: 'fit-content',
                  maxWidth: '800px',
                }}
              >
                <Box
                  component="span"
                  sx={{
                    width: 20,
                    height: 20,
                    borderRadius: '50%',
                    backgroundColor: '#FFC107',
                    color: '#fff',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: 14,
                    fontWeight: 600,
                    marginRight: '12px',
                  }}
                >
                  i
                </Box>
                <Typography
                  sx={{
                    fontSize: '14px',
                    fontWeight: 500,
                    color: '#4A4A4A',
                  }}
                >
                  Note: Clicking “Submit” will trigger an approval email to the Module Owner
                </Typography>
              </Box>

              <Box sx={{ width: "105%", marginLeft: "-32px", background: "#fff", borderTop: "1px solid #cfcfcf", marginTop: "20px", marginBottom: "10px" }}>
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <Button sx={{ fontSize: "14px", fontWeight: "500", color: "#C8172F", textTransform: "capitalize", padding: "0", marginLeft: "50px" }} onClick={() => navigate('/team-Members')}>
                    <img style={{ marginRight: "8px" }} src={arrowleft} alt="arrowleft" />Back
                  </Button>
                  <Box>


                    {/* 
<Button onClick={() => handleApprove(someId, "approved")}>Approve</Button>
<Button onClick={() => handleApprove(someId, "rejected")}>Reject</Button> */}


                    {/* {copyid?.startsWith("id:") ? (
                      <>
                        <Button
                          type="submit"

                          style={{
                            marginTop: "20px",
                            backgroundColor: "#C8102E",
                            color: "#fff",
                            border: "none",
                            padding: "10px 20px",
                            borderRadius: "8px",
                            fontWeight: "600",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleOpenConfirm();
                            handleApprove("approved");
                          }}
                        >
                          Approvesssssssss

                        </Button>

                        <Button
                          type="submit"

                          style={{
                            marginTop: "20px",
                            marginLeft: "10px",
                            backgroundColor: "#C8102E",
                            color: "#fff",
                            border: "none",
                            padding: "10px 20px",
                            borderRadius: "8px",
                            fontWeight: "600",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleOpenConfirm();
                            handleApprove("rejected");
                          }}
                        >
                          Rejected

                        </Button>
                      </>
                    ) : ( */}
                      <>
                       <Button
                                     type="submit" // Important: NOT "submit"
                               
                                   disabled={!(isValid && dirty) }
                                   sx={{
                                     marginTop: '20px',
                                     backgroundColor: isValid && dirty  ? '#C8102E' : '#ccc',
                                     color: '#fff',
                                     border: 'none',
                                     padding: '10px 20px',
                                     borderRadius: '8px',
                                     fontWeight: '600',
                                     marginRight: "50px",
                                     cursor: isValid && dirty  ? 'pointer' : 'not-allowed',
                                     '&:hover': {
                                       backgroundColor: isValid && dirty  ? '#A8102E' : '#ccc',
                                     },
                                   }}
                                 >
                                  Submit
                                   {/* {isSubmitting ? 'Submitting...' : 'Submit'} */}
                                 </Button>
                       
                        </>
                   



                    <ConfirmPopup
                      handleYes={handleYes}
                      statusdata={statusdata} setstatusdata={setstatusdata}
                      open={confirmOpen}
                      onClose={handleCloseConfirm}
                      onConfirm={handleConfirmSubmit}
                      moduleOwner={modulenamoopup} chekmodulw={0} editteammemver={0}                    />

                    <SuccessPopup
                      open={showSuccess}
                      onClose={() => setShowSuccess(false)}
                      message="Task scheduled for 300 users successfully"
                    />
                  </Box>
                </Box>
              </Box>

            </Form>
          )}
        </Formik>
      </Box>

    </Box>
  );
};

export default TeamForm;